import { useState, useRef, useEffect } from "react";
import Webcam from "webcam-react";
import "./style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import AlertMessage from "../../../components/Alert";
import { Load } from "../../../components/Load";
import AsoHeader from "../../../components/Aso/Header";
import { Button, Card } from "react-bootstrap";
import InputMask from 'react-input-mask';

// Importando os ícones
import PageviewIcon from '@mui/icons-material/Pageview';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import GppGoodIcon from '@mui/icons-material/GppGood';

const ReconhecimentoFacialAso = () => {
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [photoBase64, setPhotoBase64] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const webcamRef = useRef<any>(null);
    const { idConsulta, dbName }: any = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [imageSrc, setImageSrc] = useState(null);
    const [cpf, setCpf] = useState('');
    const [error, setError]: any = useState('');
    const [disabled, setDisabled] = useState(true);
    const [isCorrect, setIsCorrect] = useState(false);
    const [progress, setProgress] = useState(0);
    const [progressMessage, setProgressMessage] = useState('');
    const [progressIcon, setProgressIcon] = useState<any>(null);
    const [id, setId]: any = useState(null);

    const capturePhoto = async () => {
        if (webcamRef.current) {
            const dataUri = await webcamRef.current.getScreenshot();
            setPhotoBase64(dataUri);
        }
    };

    const handleContinue = async () => {
        try {
            if (photoBase64) {
                setIsLoading(true);

                const signed = await api.post(`/salvar-assinatura-aso/${dbName}`, { fotoRosto: photoBase64, idConsulta, dbName, id });
                if (signed.status === 200) {
                    setIsLoading(false);
                    setIsCorrect(true);
                    navigate("/aso/registro/documento-assinado-sucesso");
                } else {
                    setIsLoading(false);
                    setIsCorrect(false);
                    setAlert({ show: true, message: "Erro ao comparar identidade. Tente novamente.", variant: "danger" });
                }
            }
        } catch (error: any) {
            setIsLoading(false);
            setAlert({ show: true, message: "Erro ao comparar identidade. Tente novamente.", variant: "danger" });
        }
    };

    const handleRetake = () => {
        setPhotoBase64(null);
    };

    const handleSearchLogo = async () => {
        try {
            const response = await api.get(`get-logo-image/${dbName}`);
            const base64Image = response.data.data;
            const imageObjectURL: any = `data:image/png;base64,${base64Image}`;
            setImageSrc(imageObjectURL);

        } catch (error) {
            console.log(error);
        }
    };

    const handleCpfChange = (event: any) => {
        setCpf(event.target.value);
        setDisabled(!validarCPF(event.target.value));
    };

    const validarCPF = (value: string): boolean => {
        const cpfDigitos = value.replace(/\D/g, '');
        if (cpfDigitos.length !== 11) return false;
        if (/^(\d)\1{10}$/.test(cpfDigitos)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(cpfDigitos.charAt(i)) * (10 - i);
        let resto = soma % 11;
        let digitoVerificador1 = resto < 2 ? 0 : 11 - resto;
        if (parseInt(cpfDigitos.charAt(9)) !== digitoVerificador1) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(cpfDigitos.charAt(i)) * (11 - i);
        resto = soma % 11;
        let digitoVerificador2 = resto < 2 ? 0 : 11 - resto;
        if (parseInt(cpfDigitos.charAt(10)) !== digitoVerificador2) return false;

        return true;
    };

    const handleSearchCpf = async () => {
        try {
            const response = await api.post(`verificar-cpf-assinatura-aso/${cpf}/${idConsulta}/${dbName}`);
            if (response.data === true) {
                handleSearchId();
                return true;
            } else if (typeof response.data === 'string') {
                setError(response.data);
                return false;
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSearchId = async () => {
        try {
            const response = await api.post(`verificar-id-por-cpf/${cpf}`);
            console.log("🚀 ~ handleSearchId ~ response:", response)
            console.log("🚀 ~ handleSearchId ~ response.data:", response.data)
            if (response.data === false) {
                
                return;
            } else{
                setId(response.data.id);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const simulateProgress = async () => {
        const steps = [
            { percentage: 20, message: "Validando CPF", icon: <PageviewIcon style={{ fontSize: 40 }} /> },
            { percentage: 50, message: "Verificando informações cadastradas", icon: <PlagiarismIcon style={{ fontSize: 40 }} /> },
            { percentage: 75, message: "Finalizando processo de segurança", icon: <GppGoodIcon style={{ fontSize: 40 }} /> },
            { percentage: 100, message: "Concluído", icon: null }
        ];

        for (const step of steps) {
            setProgress(step.percentage);
            setProgressMessage(step.message);
            setProgressIcon(step.icon);
            await new Promise(resolve => setTimeout(resolve, 3000));  // Agora espera 3 segundos antes de mudar para o próximo step
        }

        setIsCorrect(true);
        setIsLoading(false);
    };


    const handleSubmit = async () => {
        if (await handleSearchCpf()) {
            if (validarCPF(cpf)) {
                setIsLoading(true);
                await simulateProgress();
                localStorage.setItem('cpf', cpf);
                localStorage.setItem('consulta', idConsulta);
                localStorage.setItem('dbName', dbName);
            } else {
                setAlert({ show: true, message: "Insira um CPF válido!", variant: "error" });
            }
        }
    };

    useEffect(() => {
        handleSearchLogo();
    }, []);

    return (
        <>
            {isLoading ? (
                <>
                    <AsoHeader logo={imageSrc} />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="progress-container">
                            <div className="progress-icon">
                                {progressIcon}
                            </div>
                            <div className="progress-message">
                                {progressMessage}
                            </div>
                            <div className="progress-bar" style={{ width: `${progress}%` }} />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <AsoHeader logo={imageSrc} />
                    {isCorrect === false ? (
                        <div className='aso-container-cpf'>
                            <div className='aso-titulo-container-cpf'>
                                <div className="aso-titulo-cpf">Qual é o número de CPF do usuário?</div>
                            </div>
                            <div className='aso-container-card-cpf'>
                                <Card className='aso-card-cpf'>
                                    <div className='aso-card-content-container-cpf'>
                                        <div className='aso-card-content-cpf'>
                                            <label htmlFor="cpf-input" className='label-container'>
                                                <span className='aso-card-content-cpf-label-span'>Número</span>
                                            </label>
                                            <div className='aso-card-content-container-cpf-input'>
                                                <span className='aso-card-content-cpf-input-prefix'>CPF</span>
                                                <InputMask
                                                    mask="999.999.999-99"
                                                    type="text"
                                                    pattern="[0-9]*"
                                                    id='cpf-input'
                                                    title='Digite um CPF numérico'
                                                    minLength={11}
                                                    className='aso-card-content-cpf-input'
                                                    onChange={handleCpfChange}
                                                />
                                            </div>
                                            <div className='aso-card-content-cpf-input-span'>
                                                <span>Insira apenas números, sem traços nem pontos.</span>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                                <div className='aso-button-cpf-container'>
                                    <Button
                                        variant="primary"
                                        className='aso-button-cpf-content'
                                        onClick={handleSubmit}
                                        disabled={disabled}>
                                        Continuar
                                    </Button>
                                </div>
                                {error && (
                                    <div className="error-container my-3 text-danger">
                                        <p className="error-text text-center mb-3">{error}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        !isLoading && (
                            <div className="camera-container">
                                {!photoBase64 ? (
                                    <div className="camera-wrapper">
                                        <h1 className="instruction-title">
                                            Por favor, remova quaisquer acessórios do rosto, posicione-se em
                                            um local bem iluminado e mantenha uma expressão neutra.
                                        </h1>
                                        <Webcam
                                            audio={false}
                                            screenshotFormat="image/jpeg"
                                            width={400}
                                            height={550}
                                            className="webcam"
                                            ref={webcamRef}
                                            mirrored={true}
                                        />
                                        <div className="pre-foto-buttons-container">
                                            <button onClick={capturePhoto} className="capture-button">
                                                Tirar Foto
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="confirm-wrapper">
                                        <h1 className="verification-title">
                                            Por favor, verifique se a foto está bem iluminada e se o rosto
                                            está visível antes de continuar.
                                        </h1>
                                        <img
                                            src={photoBase64 || ""}
                                            alt="Foto tirada"
                                            className="captured-image"
                                        />
                                        <div className="buttons-wrapper">
                                            <button onClick={handleContinue} className="continue-button">
                                                Continuar
                                            </button>
                                            <button onClick={handleRetake} className="retake-button">
                                                Tirar outra foto
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <AlertMessage
                                    show={alert.show}
                                    message={alert.message}
                                    variant={alert.variant}
                                    onClose={() => setAlert({ ...alert, show: false })}
                                />
                            </div>
                        )
                    )}
                </>
            )}
        </>
    );
};

export default ReconhecimentoFacialAso;
